import { create } from 'zustand';
import { RTVWMSLocation, RTVWMSPallet } from 'types';

interface MoveState {
  pallet: RTVWMSPallet | null;
  location: RTVWMSLocation | null;
  setPallet: (pallet: RTVWMSPallet | null) => void;
  setLocation: (location: RTVWMSLocation | null) => void;
  reset: () => void;
}

export const useMoveStore = create<MoveState>((set) => ({
  pallet: null,
  location: null,
  setPallet: (pallet) => set({ pallet }),
  setLocation: (location) => set({ location }),
  reset: () => set({ pallet: null, location: null }),
}));
